const _transformContentBlocksToSeoDescription = (contentsRef) => {
    const firstTextBlock = contentsRef.find((block) => block.type === 'TEXT');
    if (firstTextBlock) {
        const blockContentWithoutTags = firstTextBlock.content.replace(/(<([^>]+)>)/gi, '').replaceAll('&nbsp;', ' ');
        if (blockContentWithoutTags) {
            return blockContentWithoutTags.substring(0, 150);
        }
    }
    return '';
};
export const getDefaultSeoDescription = (content) => {
    if (content.leadText.trim()) {
        return content.leadText;
    }
    const fromTextBlocks = _transformContentBlocksToSeoDescription(content.contentsRef);
    if (fromTextBlocks) {
        return fromTextBlocks;
    }
    return content.title;
};
export const hasCustomSeoDescription = (content) => content && content.seoDescription
    ? !!content.seoDescription.trim() && content.seoDescription !== getDefaultSeoDescription(content)
    : false;
export const updateDefaultSeoDescription = (content, previousContent) => {
    if (!hasCustomSeoDescription(content) ||
        (previousContent && !hasCustomSeoDescription(previousContent) && previousContent.seoDescription === content.seoDescription)) {
        content.seoDescription = getDefaultSeoDescription(content);
    }
};
const _hasCustomSeoTitle = (content) => content && !!content.seoTitle.trim() && content.seoTitle !== content.title;
export const updateDefaultSeoTitle = (content, previousContent) => {
    if (!_hasCustomSeoTitle(content) ||
        (previousContent && !_hasCustomSeoTitle(previousContent) && previousContent.seoTitle === content.seoTitle)) {
        content.seoTitle = content.title;
    }
};
//# sourceMappingURL=seo.defaults.js.map